import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { nextAsset } from '../../../../components/nextAsset';

export const SmartlinksDescriptionArtist: React.FC = () => {
  const intl = useIntl();
  return (
    <div style={{ position: 'relative' }} className="smartlinks-subpages-description">
      <Container>
        <Row className="pt-5">
          <Col xs={12} md={4} lg={3} className="d-flex align-items-center">
            <div className="d-none d-md-block">
              <img
                src={nextAsset('images/smartLinks/home/iPhone17.png', false, { w: 900 })}
                className="img-fluid"
                alt="iphone17"
              />
            </div>
          </Col>
          <Col xs={12} md={1} lg={2} />
          <Col className="flex-column py-5">
            <h2 className="main-header pt-5 pb-3 text-white text-center text-md-start">
              {intl.formatMessage({
                id: 'sml.web.smartlinks.artist.description.title',
                defaultMessage: 'Add more to your link in bio'
              })}
            </h2>
            <p className="header-subtitle pb-4">
              {intl.formatMessage(
                {
                  id: 'sml.web.smartlinks.artist.description.subtitle',
                  defaultMessage:
                    'Artist Bio Link provides fans with everything they need to discover and learn about you and your music - in one centralized place.'
                },
                {
                  br: <br />
                }
              )}
            </p>
            <Row>
              <Col xs={12} lg={6}>
                <p className="smartlinks-description-artist">
                  {intl.formatMessage({
                    id: 'sml.web.smartlinks.artist.description.release',
                    defaultMessage: 'New single and album releases'
                  })}
                </p>
              </Col>
              <Col xs={6} lg={3}>
                <p className="smartlinks-description-artist">
                  {intl.formatMessage({
                    id: 'sml.web.smartlinks.artist.description.playlist',
                    defaultMessage: 'Playlists'
                  })}
                </p>
              </Col>
              <Col xs={6} lg={3}>
                <p className="smartlinks-description-artist">
                  {intl.formatMessage({
                    id: 'sml.web.smartlinks.artist.description.videos',
                    defaultMessage: 'Videos'
                  })}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={6} lg={4}>
                <p className="smartlinks-description-artist">
                  {intl.formatMessage({
                    id: 'sml.web.smartlinks.artist.description.upcoming',
                    defaultMessage: 'Upcoming tours'
                  })}
                </p>
              </Col>
              <Col xs={6} lg={3}>
                <p className="smartlinks-description-artist">
                  {intl.formatMessage({
                    id: 'sml.web.smartlinks.artist.description.website',
                    defaultMessage: 'Website'
                  })}
                </p>
              </Col>
              <Col xs={6} lg={3}>
                <p className="smartlinks-description-artist">
                  {intl.formatMessage({
                    id: 'sml.web.smartlinks.artist.description.social',
                    defaultMessage: 'Social media'
                  })}
                </p>
              </Col>
              <Col xs={6} lg={2}>
                <p className="smartlinks-description-artist">
                  {intl.formatMessage({
                    id: 'sml.web.smartlinks.artist.description.merch',
                    defaultMessage: 'Merch'
                  })}
                </p>
              </Col>
            </Row>
            <div className="bg-subpages-waves">
              <img src={nextAsset('images/smartLinks/wave-subpages.svg')} alt="Background Waves" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
